import { createContext, useContext, ReactNode } from "react";
import { usePremium } from "@/contexts/PremiumContext";
import { UserTier, CIRCLE_LIMITS } from "@/lib/tiers";

interface TierContextType {
  tier: UserTier;
  circleLimit: number;
}

const TierContext = createContext<TierContextType>({
  tier: UserTier.FREE,
  circleLimit: CIRCLE_LIMITS[UserTier.FREE],
});

export const useTier = () => useContext(TierContext);

export const TierProvider = ({ children }: { children: ReactNode }) => {
  const { isPremium } = usePremium();
  const tier = isPremium ? UserTier.PREMIUM : UserTier.FREE;

  return (
    <TierContext.Provider value={{ tier, circleLimit: CIRCLE_LIMITS[tier] }}>
      {children}
    </TierContext.Provider>
  );
};
